import { Segment, SegmentedButton } from '~/shared/ui'
import { useFilters } from '../../../model'

export function VisibilityFilter() {
  const { filters, setFilters } = useFilters()

  return (
    <SegmentedButton
      className="block px-4 py-2"
      size="small"
    >
      <Segment
        checked={filters.visibility === ''}
        onClick={() => setFilters({ visibility: '' })}
      >
        All Documents
      </Segment>
      <Segment
        checked={filters.visibility === 'onshore'}
        onClick={() => setFilters({ visibility: 'onshore' })}
      >
        US Based
      </Segment>
    </SegmentedButton>
  )
}
